import {KeyValuePipe} from '@angular/common'
import {Component, input} from '@angular/core'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MatOption} from '@angular/material/autocomplete'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatSelect} from '@angular/material/select'
import {sortOriginal} from '@sparbanken-syd/sparbanken-syd-theme'
import {BaseComponent} from '../base.component'

@Component({
  selector: 'spb-form-of-employment',
  imports: [
    MatFormField,
    MatLabel,
    ReactiveFormsModule,
    FormsModule,
    KeyValuePipe,
    MatOption,
    MatSelect,
    MatError,
    MatIcon,
    MatSuffix
  ],
  templateUrl: './form-of-employment.component.html',
  providers: [{provide: BaseComponent, useExisting: FormOfEmploymentComponent}]
})
/**
 * Form of employment is a binary selector. Specific KYC's will
 * have to sort out where to put if, any
 */
export class FormOfEmploymentComponent extends BaseComponent {
  public override debugName = 'form-of-employment'
  public employmentForms = input.required<Map<string, string>>()
  protected readonly sortOriginal = sortOriginal
}
